import React, { useMemo } from "react";
import { useActiveAccount } from "../accounts/hooks/useAccounts";
import { usePlan } from "../accounts/hooks/usePlan";
import { FeatureName, useFeatureFlags } from "./experiments";

/** Renders children if the named feature is enabled */
export function IfFeatureEnabled({
  feature,
  children,
}: {
  feature: FeatureName;
  children: PredicateChildren;
}) {
  const { flags } = useFeatureFlags();

  if (flags[feature]) {
    return renderPredicateChildren(children);
  }
}

/** Renders childrens on paid plans only */
export function IfPlanRequiresPayment({
  children,
}: {
  children: PredicateChildren;
}) {
  const plan = usePlan();
  if (plan?.requiresPayment) {
    return renderPredicateChildren(children);
  }

  return null;
}

/** Renders children if the current plan is self-service */
export function IfPlanIsSelfService({
  children,
}: {
  children: PredicateChildren;
}) {
  const plan = usePlan();

  if (plan?.isSelfService) {
    return renderPredicateChildren(children);
  }
  return null;
}

/** Predicate children may be an element, or a function that produces an element  */
export type PredicateChildren = (() => React.ReactNode) | React.ReactNode;

/** Helper for rendering PredicateChildren. */
function renderPredicateChildren(children: PredicateChildren) {
  return typeof children === "function" ? <>{children()}</> : <>{children}</>;
}
